export const RECAPTCHA_SITE_KEY = '6LdfpQYuAAAAALGqPctdGJEC-tJSHDCmCH_PLT6e';
export const RECAPTCHA_HEADER_KEY = 'X-Recaptcha-Token';

export const RECAPTCHA_ENDPOINTS = [
  'auth/login',
  'auth/reset-password',
  'auth/register-for-student',
  'auth/register-user-from-gcp',
  'auth/register-student-custom',
];

export const CAPTCHA_ERROR_MESSAGES: Record<string, Record<string, string>> = {
  '#captchaRequired': {
    uz: "Iltimos, captcha (men robot emasman) tekshiruvidan o'ting.",
    ru: 'Пожалуйста, пройдите проверку капчи.',
    en: 'Please complete the captcha verification.',
    kaa: "Iltimas, captcha tekseriwinen o'tin'.",
  },
  '#captchaInvalid': {
    uz: "Captcha yaroqsiz yoki eskirgan. Qaytadan urinib ko'ring.",
    ru: 'Капча недействительна или устарела. Попробуйте еще раз.',
    en: 'Captcha is invalid or expired. Please try again.',
    kaa: "Captcha jaramssiz yaki eskirdi. Qaytadan urin'ip ko'rin'.",
  },
  '#captchaUnavailable': {
    uz: "Captcha tekshiruv serveri javob bermadi. Keyinroq urinib ko'ring.",
    ru: 'Сервер проверки капчи недоступен. Попробуйте позже.',
    en: 'Captcha verification server is unavailable. Please try again later.',
    kaa: "Captcha tekseriw serveri juwap bermedi. Keyinirek urin'ip ko'rin'.",
  },
};
